
import Vue from 'vue';
import { Modal, Button } from '@descomplica/vue-components';
import ActivitiesList from '@/components/studyPlanning/undergrad/ActivitiesList.vue';
import { isMobileDevice } from '@/helpers/mobile';
import { Period } from '@/store/modules/periods/state';
import { WeekActivities } from '@/models/kingslanding/studyPlanModel';
import StudyPlanSkeleton from '@/components/skeletons/studyPlan/undergrad/StudyPlanSkeleton.vue';

interface ContentScrollPosition {
  top?: number;
  left?: number;
}

interface Data {
  isActive: Boolean;
  contentScroll: ContentScrollPosition;
  activities: WeekActivities[];
}

export default Vue.extend({
  components: {
    Modal,
    Button,
    ActivitiesList,
    StudyPlanSkeleton,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      isActive: this.active,
      contentScroll: { top: 0, left: 0 },
      activities: [],
    };
  },
  computed: {
    modalBorderRadius(): number {
      return this.isMobileDevice ? 0 : 16;
    },
    isMobileDevice(): boolean {
      return isMobileDevice();
    },
    isLoadingStudyPlanTemplate(): boolean {
      return this.$store.getters.isLoadingStudyPlanTemplate;
    },
    currentPeriod(): Period {
      return this.$store.getters.userCurrentPeriod;
    },
    currentWeek(): number {
      return this.$store.getters.currentWeek;
    },
    lastPreviousWeekLoaded(): number {
      return this.$store.getters.lastPreviousWeekLoaded;
    },
    lastNextWeekLoaded(): number {
      return this.$store.getters.lastNextWeekLoaded;
    },
    isFirstWeekLoaded(): boolean {
      return this.$store.getters.isFirstWeekLoaded;
    },
    isLastWeekLoaded(): boolean {
      return this.$store.getters.isLastWeekLoaded;
    },
    hasStudyPlanToDisplay(): boolean {
      return this.$store.getters.currentStudyPlanId > 0;
    },
  },
  watch: {
    async isActive(active: boolean) {
      if (!active) {
        this.activities = [];
        return;
      }

      const currentWeekActivities = this.currentWeekActivities();

      if (currentWeekActivities) {
        this.activities.push(currentWeekActivities);
      }

      if (this.isLastWeekLoaded) {
        this.showAllLoadedNextWeeks();
      }
    },
  },
  updated() {
    this.isActive = this.active;
  },
  methods: {
    backToTop(): void {
      this.contentScroll = { top: 0 };
    },
    updateActive(active: boolean): void {
      this.$emit('update:active', active);
    },
    currentWeekActivities(): WeekActivities | undefined {
      return this.$store.getters.activitiesByWeek(this.currentWeek);
    },
    showPreviousWeek(): void {
      if (this.isFirstWeekLoaded) return;

      this.$store.dispatch('LOAD_PREVIOUS_WEEK');

      const activities = this.$store.getters.activitiesByWeek(this.lastPreviousWeekLoaded);
      this.activities.unshift(activities);
    },
    showNextWeek(): void {
      if (this.isLastWeekLoaded) return;

      const activities: WeekActivities = this.$store.getters.activitiesByWeek(
        this.lastNextWeekLoaded + 1,
      );

      this.$store.dispatch('LOAD_NEXT_WEEK');

      this.activities.push(activities);
    },
    showAllLoadedNextWeeks(): void {
      for (let week = this.currentWeek + 1; week <= this.lastNextWeekLoaded; week += 1) {
        const activities: WeekActivities = this.$store.getters.activitiesByWeek(week);
        this.activities.push(activities);
      }
    },
  },
});
